import { BrokersPage } from '@/features/brokers/components';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { requirePermissions } from '@/shared/utils';

export const Route = createFileRoute('/_app/brokers/')({
  component: RouteComponent,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['parties.brokers.read']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function RouteComponent() {
  return <BrokersPage />;
}
